import { useLocation, useNavigate } from "react-router-dom";
import TokenError from "../tokenError";
import { Button, Grid, Grid2, Menu, MenuItem, Select, Snackbar, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import EventSeatIcon from "@mui/icons-material/EventSeat";
import AccessibleIcon from "@mui/icons-material/Accessible";
import windowSeat from '../../assets/images/windowSeat.svg';
import aisleSeat from '../../assets/images/aisleSeat.svg';
import inactiveSeat from '../../assets/images/inactiveSeat.svg';
import specialSeat from '../../assets/images/specialSeat.svg';
import middleSeat from '../../assets/images/middleSeat.svg';
import inactiveNew from '../../assets/icons/inactiveNew.svg';
import aisleImage from '../../assets/images/AisleImage.svg';
import rearImage from '../../assets/images/RearImage.svg';
import addCircle from '../../assets/images/addCircle.svg';
import removeCircle from '../../assets/images/removeCircle.svg';
import femaleSeat from '../../assets/images/femaleSeat.svg';
import windowAisle from '../../assets/images/windowAisle.svg';
import config from "../../config/config";
import { makeGetRequestToUrl, makePostRequestToUrl } from "../commonFunc";

const ShuttleSeatStructure = () => {
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const token = localStorage.getItem('token');
    const location = useLocation();
    const navigate = useNavigate();
    const rowData = location.state?.rowData;

    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [seatStructureData, setSeatStructureData] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedSeat, setSelectedSeat] = useState(null);
    const [openEdit, setOpenEdit] = useState(false);
    const [modifiedSeats, setModifiedSeats] = useState([]);
    const [modifiedSeats2, setModifiedSeats2] = useState([]);
    const [selectedSeatNumbers, setSelectedSeatNumbers] = useState({});
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [subtracting, setSubtracting] = useState(false);
    const [subtractingModifiedSeats, setSubtractingModifiedSeats] = useState([]);
    const [action, setAction] = useState(false);

    const [rearSeatStrutureData, setRearSeatStructureData] = useState([]);
    const [isRear, setIsRear] = useState(false);
    const [rearSeatingMatrix, setRearSeatingMatrix] = useState([]);
    const [isAisle, setIsAisle] = useState('');


    const handleSeatChange = (seatId, newValue) => {
        setSelectedSeatNumbers(prev => ({
            ...prev,
            [seatId]: { seat_number: Number(newValue), seat_type: prev[seatId]?.seat_type || 1 }
        }));
    };

    const handleOpenEdit = () => {
        setOpenEdit(true);
    }

    const fetchSeatData = async() => {
        try {
            const url = serverUrl + '/shuttle/fetch_vehicle_seat_structure';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                vehicle_id: rowData.id,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if (response.flag === 200) {
                const seatData = response.data.filter(item => item.is_rear === 0);
                const rearSeatData = response.data.filter(item => item.is_rear !== 0);
                const topRow = response.data;
                for(let i=0;i<topRow.length;i++){
                    if(topRow[i].is_aisle==1){
                        setIsAisle(topRow[i].col_id);
                    }
                }
                
                setSeatStructureData(seatData);
                setRearSeatStructureData(rearSeatData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }
    useEffect(() => {
        if(action==true) handleSubmitData();
    }, [action]);
    
    // const addColumnOnLeft = () => {
    //     setIsAisle(isAisle+1);

    //     if(seatingMatrix.length==0){
    //         showSnackbar(true);
    //         setMessage('You need to add row first.');
    //         return;
    //     }

    //     let matrixWithoutNull = seatingMatrix.map(row => row.filter(cell => cell !== null));

    //     // Step 2: Ensure the new matrix doesn't have columns with null values.
    //     const numColumns = seatingMatrix[0].length;
        
    //     if(matrixWithoutNull[0].length==6){
    //         showSnackbar(true);
    //         setMessage('You are not allowed to add more than 6 columns.');
    //         return;
    //     }
    //     let totalSeatCount = (seatingMatrix.length) * (seatingMatrix[0].length);
    //     setSeatingMatrix(prev => {
    //       // Array to collect seats whose types have been changed.
    //       const changedSeats = [];
    //       // Calculate total number of existing (non-null) seats.
    //       const totalSeatsBefore = prev.flat().filter(seat => seat !== null).length;
          
    //       const updatedMatrix = prev.map((row, rowIndex) => {
    //         // Deep clone the row.
    //         let updatedRow = row.map(seat => seat ? { ...seat } : seat);
            
    //         // Find the index of the first aisle seat (seat_type === 3).
    //         const firstAisleIndex = updatedRow.findIndex(seat => seat && (seat.seat_type === 3 || seat.seat_type==7));
            
    //         if (firstAisleIndex !== -1) {
    //           // Convert the first aisle seat to a middle seat.
    //           updatedRow[firstAisleIndex] = {
    //             ...updatedRow[firstAisleIndex],
    //             seat_type: 2  // Middle seat
    //           };
    //           changedSeats.push(updatedRow[firstAisleIndex]);
              
    //           // Instead of using immediate index + 1, find the seat with the smallest col_id greater than that of the first aisle.
    //           const firstAisleColId = updatedRow[firstAisleIndex].col_id;
    //           let nextSeatIndex = null;
    //           let minColId = Infinity;
              
    //           updatedRow.forEach((seat, idx) => {
    //             if (seat && seat.col_id > firstAisleColId && seat.col_id < minColId) {
    //               minColId = seat.col_id;
    //               nextSeatIndex = idx;
    //             }
    //           });
              
    //           // If a next seat is found, update its type to aisle.
    //           if (nextSeatIndex !== null && updatedRow[nextSeatIndex]) {
    //             updatedRow[nextSeatIndex] = {
    //               ...updatedRow[nextSeatIndex],
    //               seat_type: 3  // Aisle seat
    //             };
    //             changedSeats.push(updatedRow[nextSeatIndex]);
    //           }
    //         }
            
    //         // Append a new seat at the extreme right.
    //         const newSeat = {
    //           vehicle_id: rowData.id,          // Adjust as needed.
    //           row_id: rowIndex + 1,
    //           col_id: updatedRow.length + 1,     // New seat gets the next column index.
    //           seat_type: 1,                    // Default seat type (e.g. window seat).
    //           seat_number: totalSeatCount + 1 + rowIndex,
    //           is_active: 1,
    //           is_aisle: 0
    //         };
    //         updatedRow.push(newSeat);
            
    //         return updatedRow;
    //       });
          
    //       // Extract the newly added seats (last seat in each row).
    //       const newSeats = updatedMatrix.map(row => row[row.length - 1]);
    //       // Update the modifiedSeats state with the new seats.
    //       setModifiedSeats(prevModified => [...prevModified, ...newSeats]);
    //       // Update modifiedSeats2 state with the seats that had type changes.
    //       setModifiedSeats2(prevModified2 => [...prevModified2, ...changedSeats]);
          
    //       return updatedMatrix;
    //     });
    //     setAction(true);
    // };
      
      
    // const subtractColumnOnLeft = () => {
    //     if(seatingMatrix.length==0){
    //         showSnackbar(true);
    //         setMessage('You need to add row first.');
    //         return;
    //     }
    //     setIsAisle(isAisle-1);
    //     setSeatingMatrix(prev => {
    //       // Array to collect modified seats.
    //       const changedSeats = [];
      
    //       const updatedMatrix = prev.map(row => {
    //         // Only modify rows that have more than one seat.
    //         if (row.length > 1) {
    //           // Deep clone the row.
    //           const newRow = row.map(seat => (seat ? { ...seat } : seat));
      
    //           // Find the first aisle seat in terms of column order: the seat with seat_type === 3 and smallest col_id.
    //           const firstAisleSeat = newRow.reduce((acc, seat) => {
    //             if (seat && (seat.seat_type === 3 || seat.seat_type === 7)) {
    //               return (!acc || seat.col_id < acc.col_id) ? seat : acc;
    //             }
    //             return acc;
    //           }, null);
      
    //           if (firstAisleSeat) {
    //             // Find the seat with the highest col_id less than the firstAisleSeat.col_id.
    //             const precedingSeat = newRow.reduce((acc, seat) => {
    //               if (seat && seat.col_id < firstAisleSeat.col_id) {
    //                 return (!acc || seat.col_id > acc.col_id) ? seat : acc;
    //               }
    //               return acc;
    //             }, null);
      
    //             // If a preceding seat exists, update its seat_type to aisle (3) and record the change.
    //             if (precedingSeat) {
    //               const precedingIndex = newRow.findIndex(
    //                 s => s && s.col_id === precedingSeat.col_id
    //               );
    //               if (precedingIndex !== -1) {
    //                 newRow[precedingIndex] = {
    //                   ...newRow[precedingIndex],
    //                   seat_type: 3
    //                 };
    //                 changedSeats.push(newRow[precedingIndex]);
    //               }
    //             }
      
    //             // Remove the first aisle seat: mark it inactive and record it.
    //             const aisleIndex = newRow.findIndex(
    //               s => s && s.col_id === firstAisleSeat.col_id
    //             );
    //             if (aisleIndex !== -1) {
    //               const removedAisleSeat = {
    //                 ...newRow[aisleIndex],
    //                 is_active: 0
    //               };
    //               changedSeats.push(removedAisleSeat);
    //               newRow.splice(aisleIndex, 1);
    //             }
    //           }
    //           return newRow;
    //         }
    //         return row;
    //       });
      
    //       // Update modifiedSeats with the changed seats.
    //       setSubtractingModifiedSeats(prevModified => [...prevModified, ...changedSeats]);
      
    //       return updatedMatrix;
    //     });
    //     setSubtracting(true);
    //     setAction(true);
    // };
      
    const subtractRear = () =>{
        if (rearSeatingMatrix && rearSeatingMatrix.length > 0) {
            setRearSeatingMatrix(prev => {
                // Get the last row which is about to be removed
                const removedRow = prev[prev.length - 1];
                // Remove the last row from the seating matrix
                const newMatrix = prev.slice(0, -1);
        
                setSubtractingModifiedSeats(prevModified => {
                const removedSeats = removedRow
                    .filter(seat => seat !== null)
                    .map(seat => ({ ...seat, is_active: 0, is_rear: 1 }));
                return [...prevModified, ...removedSeats];
                });
        
                return newMatrix;
            });
            setSubtracting(true);
        }
        setIsRear(true);
        setAction(true);
    }
    const addRear = () => {
        if(seatingMatrix.length==0){
            setMessage('You need to add row first.');
            showSnackbar(true);
            return;
        }
        // console.log('rear seating matrix = ', rearSeatingMatrix);
        // console.log('rear seating matrix 2 = ', seatingMatrix);
        if(rearSeatingMatrix.length - seatingMatrix.length >=1) {
            setMessage('You cannot add more than one rear seat.');
            showSnackbar(true);
            return;
        }

        setRearSeatingMatrix(prev => {
            
            const newRowId = prev.length > 0 ? prev[prev.length - 1][0]?.row_id : seatingMatrix.length;
        
            // Use the last row of seatingMatrix as a template.
            const lastRow = seatingMatrix[seatingMatrix.length - 1] || [];
            
            // Calculate the total number of non-null seats currently in the rear matrix.
            const totalSeatsCount = prev.flat().filter(seat => seat !== null).length;
            const totalMatrixSeatCount = seatStructureData.length;
            
            // Create a new row by mapping over the template row.
            let lastRowLen=0;
            const newRow = lastRow.map((seat, colIndex) => {
                if (!seat) return null;
            
                // Set seat_type to 2 for all seats except the first and last
                const seatType = (colIndex === 0 || colIndex === lastRow.length) ? 1 : 2;
                lastRowLen = lastRow.length;
            
                // Create a copy of the seat with updated properties.
                const newSeat = {
                    ...seat,
                    seat_type: seatType,   // Dynamically set seat_type based on position
                    seat_number: seat.col_id + totalMatrixSeatCount,  // Adjust seat_number as needed.
                    row_id: newRowId + 1,  // Use the new row id.
                    is_rear: 1,
                    is_aisle: 0,
                    col_id: colIndex + 1   // Reassign column order starting at 1.
                };
            
                // Remove the seat_id property to indicate it's a new seat.
                delete newSeat.seat_id;
                return newSeat;
            });
            
            // Append an extra seat at the end (new column) for the new row.
            const extraSeat = {
                vehicle_id: rowData.id,    // Adjust as needed.
                row_id: newRowId + 1,
                col_id: newRow.length + 1,
                seat_type: 1,              // Set seat_type to 1 for the last seat.
                seat_number: totalMatrixSeatCount + lastRowLen + 1,
                is_active: 1,
                is_rear: 1
            };
            newRow.push(extraSeat);
            
            // Update modifiedSeats with all seats in the new row (excluding any nulls).
            const newSeats = newRow.filter(seat => seat !== null);
            setModifiedSeats(prevModified => [...prevModified, ...newSeats]);
            
            // Append the new row to the rear seating matrix.
            return [...prev, newRow];
        });
        setIsRear(true);
        setAction(true);
    };
      
    const [seatingMatrix, setSeatingMatrix] = useState([]);

    useEffect(() => {
        const maxRow = Math.max(...seatStructureData.map(seat => seat.row_id));
        const maxCol = Math.max(...seatStructureData.map(seat => seat.col_id));
        
        const matrix = Array.from({ length: maxRow }, () => new Array(maxCol).fill(null));
        seatStructureData.forEach(seat => {
            matrix[seat.row_id - 1][seat.col_id - 1] = seat;
        });
        
        setSeatingMatrix(matrix);
    }, [seatStructureData]);

    useEffect(() => {
        const maxRow = Math.max(...rearSeatStrutureData.map(seat => seat.row_id));
        const maxCol = Math.max(...rearSeatStrutureData.map(seat => seat.col_id));
        
        const matrix = Array.from({ length: maxRow }, () => new Array(maxCol).fill(null));
        rearSeatStrutureData.forEach(seat => {
            matrix[seat.row_id - 1][seat.col_id - 1] = seat;
        });
        
        setRearSeatingMatrix(matrix);
    }, [rearSeatStrutureData]);

    const addRowOnRight = () => {
        if(seatingMatrix.length >= 15){
            setMessage('You cannot add more than 15 rows.');
            showSnackbar(true);
            return;
        }
        // Update the main seating matrix with a new row.
        setSeatingMatrix(prev => {
          // Get the last row; if none exists, default to an empty array.
          const lastRow = prev[prev.length - 1] || [];

          if(lastRow.length==0){
            const firstRow=[];
            for(let i=1;i<=2;i++){
                if(i==2){
                    const newSeat={
                        vehicle_id: rowData.id,
                        row_id: 1,
                        col_id: i,
                        seat_number: i,
                        seat_type: 3,
                        is_active: 1
                    }
                    firstRow.push(newSeat);
                }
                else{
                    const newSeat={
                        vehicle_id: rowData.id,
                        row_id: 1,
                        col_id: i,
                        seat_number: i,
                        seat_type: 1,
                        is_active: 1
                    }
                    firstRow.push(newSeat);
                }
            }
            setModifiedSeats([...firstRow]);
            return [firstRow];
          }
          // Assume that all seats in a row share the same row_id.
          const previousRowId = lastRow.length > 0 ? lastRow[0]?.row_id : 0;
          const newRowId = previousRowId + 1;
        
          // Calculate total non-null seats so far (for seat_number calculation)
          const totalSeatsCount = prev.flat().filter(seat => seat !== null).length;
        
          // Create a new row by mapping over the last row as a template.
          const newRow = lastRow.map((seat, colIndex) => {
            if (!seat) return null;
            // Create a copy of the seat without seat_id and update row_id.
            const newSeat = {
              ...seat,
              // Optionally update seat_number; adjust logic as needed.
              seat_number: seat.col_id + totalSeatsCount,
              row_id: newRowId, // Update to new row id.
            };
            // Remove the seat_id property if it exists.
            delete newSeat.seat_id;
            return newSeat;
          });
        
          // Update modifiedSeats with the new seats.
          const newSeats = newRow.filter(seat => seat !== null);
          setModifiedSeats(prevModified => [...prevModified, ...newSeats]);
        
          // Append the new row to the seating matrix.
          return [...prev, newRow];
        });
        
        // Update the rear seating matrix by incrementing each seat's row_id by 1.
        setRearSeatingMatrix(prevRear => {
          // For each seat in each row, increment row_id by 1.
          const updatedRear = prevRear.map(row =>
            row.map(seat => (seat ? { ...seat, row_id: seat.row_id + 1 } : seat))
          );
          // Flatten and filter out any null values.
          const updatedSeatsFlat = updatedRear.flat().filter(seat => seat !== null);
          // Update modifiedSeats2 with the updated rear seats.
          setModifiedSeats2(prevModified2 => [...prevModified2, ...updatedSeatsFlat]);
          return updatedRear;
        });
        
        setAction(true);
    };
      
    const subtractRowOnRight = () => {
        // Only subtract if there's more than one row in seatingMatrix
        if (seatingMatrix && seatingMatrix.length > 0) {
          // Update seatingMatrix: remove the last row.
          setSeatingMatrix(prev => {
            // Get the last row that will be removed.
            const removedRow = prev[prev?.length - 1];
            // Remove the last row from the seating matrix.
            const newMatrix = prev.slice(0, -1);
      
            // Mark each seat in the removed row as inactive and store in subtractingModifiedSeats.
            setSubtractingModifiedSeats(prevModified => {
              const removedSeats = removedRow
                .filter(seat => seat !== null)
                .map(seat => ({ ...seat, is_active: 0 }));
              return [...prevModified, ...removedSeats];
            });
      
            return newMatrix;
          });
      
          // Update the rearSeatingMatrix by decrementing row_id for every seat by 1.
          setRearSeatingMatrix(prevRear => {
            const updatedRear = prevRear.map(row =>
              row.map(seat => seat ? { ...seat, row_id: seat.row_id - 1 } : seat)
            );
      
            // Collect all updated seats into a flat array.
            const changedRearSeats = updatedRear.flat().filter(seat => seat !== null);
            // Append these changed seats to modifiedSeats2.
            setModifiedSeats2(prevModified2 => [...prevModified2, ...changedRearSeats]);
      
            return updatedRear;
          });
      
          setSubtracting(true);
        }
        setAction(true);
    };
      
    const addColumnOnRight = () => {

        if(seatingMatrix.length==0){
            showSnackbar(true);
            setMessage('You need to add row first.');
            return;
        }

        let matrixWithoutNull = seatingMatrix.map(row => row.filter(cell => cell !== null));

        const numColumns = seatingMatrix[0].length;
        
        console.log('matrixWithoutNull==', matrixWithoutNull, ' numColumns=', numColumns);
        
        if(matrixWithoutNull[0].length==6){
            showSnackbar(true);
            setMessage('You are not allowed to add more than 6 columns.');
            return;
        }
        let totalSeatCount = (seatingMatrix.length) * (seatingMatrix[0].length);
        setSeatingMatrix(prev => {
            const totalSeatsBefore = prev.flat().filter(seat => seat !== null).length;
            const updatedMatrix = prev.map((row, rowIndex) => {
                const newSeat = {
                    vehicle_id: rowData.id,
                    row_id: rowIndex + 1,
                    col_id: row.length + 1,
                    seat_type: 1, // Window seat
                    // Calculate a new seat_number unique for each new seat
                    seat_number: totalSeatCount + rowIndex + 1,
                    
                    is_active: 1,
                };
                // return [...row, newSeat];
                const updatedRow = [...row, newSeat];
                const modifiedRowSeats = [];
                // Now, update seat_type for seats with col_id between (isAisle + 1) and last col_id
                updatedRow.forEach(seat => {
                    if (seat.col_id > isAisle+1 && seat.col_id < updatedRow.length) {
                        if (seat.seat_type === 1) {
                            seat.seat_type = 2;
                            modifiedRowSeats.push(seat); // Add to modifiedSeats if seat_type changes
                        }
                    }
                    if(seat.col_id == row.length && seat.seat_type === 1){
                        seat.seat_type = 3;
                        modifiedRowSeats.push(seat); // Add to modifiedSeats if seat_type changes
                    }
                });
                setModifiedSeats2(prevModified => [...prevModified, ...modifiedRowSeats]);
                return updatedRow;
            });

            const newSeats = updatedMatrix.map(row => row[row.length - 1]);
            setModifiedSeats(prevModified => [...prevModified, ...newSeats]);
            return updatedMatrix;
        });
        setRearSeatingMatrix(prev => {
            if (prev.length === 0) return prev; // No rear row to modify
    
            const rearMatrix = [...prev];
            const lastRearRow = [...rearMatrix[rearMatrix.length - 1]];
    
            const lastSeat = lastRearRow[lastRearRow.length - 1];
            const newColId = lastSeat?.col_id + 1 || 1;
            const totalMatrixSeatCount = seatStructureData.length + seatingMatrix.length;
    
            // ✅ Update previous rear seat type to middle (2)
            if (lastSeat) {
                lastSeat.seat_type = 2;
                setModifiedSeats2(prev => [...prev, lastSeat]);
            }
    
            // ✅ Create new rear seat
            const newRearSeat = {
                vehicle_id: rowData.id,
                row_id: lastSeat?.row_id || seatingMatrix.length + 1,
                col_id: newColId,
                seat_type: 1,
                seat_number: totalMatrixSeatCount + newColId,
                is_active: 1,
                is_rear: 1,
            };
    
            lastRearRow.push(newRearSeat);
            rearMatrix[rearMatrix.length - 1] = lastRearRow;
    
            setModifiedSeats(prev => [...prev, newRearSeat]);
    
            return rearMatrix;
        });
    
        setAction(true);
    };

    const subtractColumnOnRight = () => {
        if(seatingMatrix.length==0){
            showSnackbar(true);
            setMessage('You need to add row first.');
            return;
        }
        setSeatingMatrix(prev => {
          // Array to collect removed seats from each row
            const removedSeats = [];
            
            // Update each row by removing the last seat if the row has more than one seat
            const updatedMatrix = prev.map(row => {
                if (row.length > 1) {
                    // Get the removed seat (the last element)
                    const removedSeat = row[row.length - 1];
                    if (removedSeat !== null) {
                        removedSeats.push({ ...removedSeat, is_active: 0 });
                    }

                    const secondToLastSeat = row[row.length - 2];
                    if (secondToLastSeat !== null) {
                        secondToLastSeat.seat_type = 1;
                        modifiedSeats2.push({ ...secondToLastSeat });
                    }

                    return row.slice(0, -1);
                }
                return row;
            });
            
            // Update modifiedSeats with the removed seats
            setSubtractingModifiedSeats(prevModified => [...prevModified, ...removedSeats]);
            
            return updatedMatrix;
        });

        // ✅ Now remove the last rear seat (not the whole row)
        setRearSeatingMatrix(prev => {
            if (prev.length === 0) return prev;

            const rearMatrix = [...prev];
            const lastRowIndex = rearMatrix.length - 1;
            const rearRow = [...rearMatrix[lastRowIndex]];

            if (rearRow.length <= 1) {
                // Optionally: if only one seat left, remove the rear row completely
                rearMatrix.pop();
                return rearMatrix;
            }

            // Remove the last rear seat
            const removedRearSeat = rearRow.pop();
            if (removedRearSeat) {
                setSubtractingModifiedSeats(prev => [
                    ...prev,
                    { ...removedRearSeat, is_active: 0 }
                ]);
            }

            // Optional: Change seat_type of new last rear seat to window (1)
            const newLastSeat = rearRow[rearRow.length - 1];
            if (newLastSeat) {
                newLastSeat.seat_type = 1;
                setModifiedSeats2(prev => [...prev, { ...newLastSeat }]);
            }

            rearMatrix[lastRowIndex] = rearRow;
            return rearMatrix;
        });

        setSubtracting(true);
        setAction(true);
    };

    useEffect(()=>{
        fetchSeatData();
    },[]);

    const handleClick = (event, seat) => {
        setAnchorEl(event.currentTarget);
        setSelectedSeat(seat);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSeatTypeChange = (seatType) => {
        // If selectedSeat has is_rear === 1, update rearSeatingMatrix, otherwise seatingMatrix.
        if (selectedSeat?.is_rear) {
          setRearSeatingMatrix(prevMatrix =>
            prevMatrix.map(row =>
              row.map(seat =>
                seat?.seat_id === selectedSeat?.seat_id
                  ? { ...seat, seat_type: seatType }
                  : seat
              )
            )
          );
        } else {
          setSeatingMatrix(prevMatrix =>
            prevMatrix.map(row =>
              row.map(seat =>
                seat?.seat_id === selectedSeat?.seat_id
                  ? { ...seat, seat_type: seatType }
                  : seat
              )
            )
          );
        }
        // Update the selectedSeatNumbers for the changed seat
        setSelectedSeatNumbers(prev => ({
            ...prev,
            [selectedSeat.seat_id]: {
            seat_number: selectedSeat.seat_number,
            seat_type: seatType
            }
        }));

        handleClose();
    };

    const savingStructure = () => {
        handleSubmitData();
        setOpenEdit(false);
    }
    const handleSubmitData = async() => {
        // console.log('matrix in save button', modifiedSeats);
        // console.log('matrix in save button2222', modifiedSeats2);
        // console.log('saving updated data', seatingMatrix);
        // console.log('setSubtracting', subtracting);
        // console.log('subtractingModified', subtractingModifiedSeats);

        // if(isAisle < 0){
        //     setMessage('Seats after which aisle appears cannot be less than 0');
        //     showSnackbar(true);
        //     fetchSeatData();
        //     return;
        // }
        // if(isAisle > seatingMatrix[0]?.length){
        //     setMessage(`Seats after which aisle appears cannot be more than ${seatingMatrix[0].length-1}`);
        //     showSnackbar(true);
        //     fetchSeatData();
        //     return;
        // }

        const seatArray = Object.entries(selectedSeatNumbers).map(([seat_id, data]) => ({
            seat_id: Number(seat_id),
            seat_number: data.seat_number,
            seat_type: data.seat_type
        }));

        const hasInvalidSeat = Object.values(selectedSeatNumbers).some(data => data.seat_number === 0);
        if (hasInvalidSeat) {
            setMessage('Seat number cannot be 0');
            showSnackbar(true);
            fetchSeatData();
            return;
        }

        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            vehicle_id: rowData.id,
        };

        payload.aisle_column_id = isAisle;

        let updatedSeats=[];
        // if(subtracting==true){
            updatedSeats = subtractingModifiedSeats;
        // }
        if(modifiedSeats.length>0)
            payload.seats = modifiedSeats;

        if(modifiedSeats2.length>0){
            for(let i=0;i<modifiedSeats2.length;i++)
            updatedSeats.push(modifiedSeats2[i]);
        }

        if(seatArray.length>0){
            for(let i=0;i<seatArray.length;i++){
                updatedSeats.push(seatArray[i]);
            }
        }

        if(updatedSeats.length>0){
            payload.updated_seats = updatedSeats;
        }

        try {
            const url = operationsUrl + '/shuttle/add_update_seat_structure';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage('Seats updated successfully.')
                showSnackbar(true);
                // setOpenEditModal(false);
                setSelectedSeatNumbers({});
                fetchSeatData();
                setModifiedSeats([]);
                setModifiedSeats2([]);
                setSubtracting(false);
                setSubtractingModifiedSeats([]);
                // setOpenEdit(false);
                setAction(false);
                setIsRear(false);
            }
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
            else {
                setMessage(response.message)
                // showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }
    }

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    // const aislePosition = async(newAisleValue) => {
    //     setIsAisle(newAisleValue);

    //     console.log('isAisle = ', newAisleValue);

    //     const payload = {
    //         token: token,
    //         vehicle_id: rowData.id,
    //         aisle_column_id: newAisleValue,
    //     };
    //     let aisleUpdatedSeats = [];
    //     // payload.updated_seats = updatedSeats;

    //     setSeatingMatrix(prev => {
    //         const seatingMatrix = prev.map((row, rowIndex) => {
    //             let updatedRow = row.map(seat => seat ? { ...seat } : seat);
    
    //             // If newAisleValue is not -1, proceed to update aisle seat types
    //             if (newAisleValue !== -1) {
    //                 // Iterate through the row and change seat_type to 3 (Aisle Seat) for all seats with col_id matching newAisleValue
    //                 updatedRow.forEach((seat, idx) => {
    //                     if (seat && seat.col_id === newAisleValue) {
    //                         updatedRow[idx] = {
    //                             ...seat,
    //                             seat_type: 3, // Mark this seat as Aisle Seat
    //                         };
    //                         aisleUpdatedSeats.push(updatedRow[idx]); // Add the updated seat to the changed seats list
    //                     }
    //                 });
    
    //                 // Optionally, handle the next seat with the smallest col_id greater than newAisleValue (if required)
    //                 const firstAisleSeat = updatedRow.find(seat => seat && seat.col_id === newAisleValue);
    //                 if (firstAisleSeat) {
    //                     const firstAisleColId = firstAisleSeat.col_id;
    //                     let nextSeatIndex = null;
    //                     let minColId = Infinity;
    
    //                     // Find the seat with the smallest col_id greater than the first aisle seat's col_id
    //                     updatedRow.forEach((seat, idx) => {
    //                         if (seat && seat.col_id > firstAisleColId && seat.col_id < minColId) {
    //                             minColId = seat.col_id;
    //                             nextSeatIndex = idx;
    //                         }
    //                     });
    
    //                     // If a next seat is found, update its type to aisle
    //                     if (nextSeatIndex !== null && updatedRow[nextSeatIndex]) {
    //                         updatedRow[nextSeatIndex] = {
    //                             ...updatedRow[nextSeatIndex],
    //                             seat_type: 3,  // Aisle seat
    //                         };
    //                         aisleUpdatedSeats.push(updatedRow[nextSeatIndex]);
    //                     }
    //                 }
    //             }
    
    //             return updatedRow;
    //         });
    
    //         // Return the updated seating matrix
    //         return seatingMatrix;
    //     });

    //     payload.updated_seats = aisleUpdatedSeats;

    //     try {
    //         const url = operationsUrl + '/shuttle/add_update_seat_structure';
    //         const response = await makePostRequestToUrl(url,payload);
    //         if (response.flag === 200) {
    //             setMessage('Seats updated successfully.')
    //             showSnackbar(true);
    //             // setOpenEditModal(false);
    //             setSelectedSeatNumbers({});
    //             fetchSeatData();
    //             setModifiedSeats([]);
    //             setModifiedSeats2([]);
    //             setSubtracting(false);
    //             setSubtractingModifiedSeats([]);
    //             // setOpenEdit(false);
    //             setAction(false);
    //             setIsRear(false);
    //         }
    //         else if(response.flag==102){
    //             console.log('Token is expired. Please login again')
    //             localStorage.removeItem('token');
    //             setErrorMessage('Your session has expired. Please log in again.');
    //             setTokenExpired(true);

    //             setTimeout(() => {
    //                 navigate('/signup');
    //             }, 2000);
    //             // navigate('/signup');
    //         }
    //         else {
    //             setMessage(response.message)
    //             // showSnackbar(true);
    //         }

    //     } catch (error) {
    //         console.error('Error while saving document:', error);
    //         setMessage(error);
    //     }
    // }

    const aislePosition = async (newAisleValue) => {
        setIsAisle(newAisleValue);
    
        const aisleUpdatedSeats = [];  // Declare this outside setSeatingMatrix
        const localSeatingMatrix = seatingMatrix;
    
        localSeatingMatrix.forEach((row) => {
            // Iterate over each seat in the row (each column in the 2D array)

            if(newAisleValue==1){
                row.forEach((seat) => {
                    if (seat?.col_id === 1) {
                        aisleUpdatedSeats.push({
                            ...seat,
                            seat_type: 1  //window
                        });
                    }
                    else if (seat?.col_id === 2) {
                        aisleUpdatedSeats.push({
                            ...seat,
                            seat_type: 3
                        });
                    }
                    else {
                        if (seat?.col_id === row.length) {
                            aisleUpdatedSeats.push({
                                ...seat,
                                seat_type: 1
                            });
                        } else {
                            // Other seats should have seat_type 2
                            aisleUpdatedSeats.push({
                                ...seat,
                                seat_type: 2
                            });
                        }
                    }
                });
            }
            
            else if(newAisleValue==2){
                row.forEach((seat) => {
                    if(seat?.col_id === 1){
                        aisleUpdatedSeats.push({
                            ...seat,
                            seat_type: 1  //window
                        });
                    }
                    else if (seat?.col_id === 2 || seat?.col_id === 3) {
                        aisleUpdatedSeats.push({
                            ...seat,
                            seat_type: 3
                        });
                    }
                    else{
                        if (seat?.col_id === row.length) {
                            aisleUpdatedSeats.push({
                                ...seat,
                                seat_type: 1
                            });
                        } else {
                            // Other seats should have seat_type 2
                            aisleUpdatedSeats.push({
                                ...seat,
                                seat_type: 2
                            });
                        }
                    }
                })
            }

            else if(newAisleValue==3){
                row.forEach((seat) => {
                    if(seat.col_id === 1 || seat.col_id === row.length){
                        aisleUpdatedSeats.push({
                            ...seat,
                            seat_type: 1  //window
                        });
                    }
                    else if (seat.col_id === 3 || seat.col_id === 4) {
                        aisleUpdatedSeats.push({
                            ...seat,
                            seat_type: 3  //aisle
                        });
                    }
                    else{
                        // Other seats should have seat_type 2
                        aisleUpdatedSeats.push({
                            ...seat,
                            seat_type: 2
                        });
                    }
                })
            }

            else if(newAisleValue==4){
                row.forEach((seat) => {
                    if(seat.col_id === 1 || seat.col_id === row.length){
                        aisleUpdatedSeats.push({
                            ...seat,
                            seat_type: 1  //window
                        });
                    }
                    else if (seat.col_id === 4 || seat.col_id === 5) {
                        aisleUpdatedSeats.push({
                            ...seat,
                            seat_type: 3  //aisle
                        });
                    }
                    else{
                        // Other seats should have seat_type 2
                        aisleUpdatedSeats.push({
                            ...seat,
                            seat_type: 2
                        });
                    }
                })
            }

            else if(newAisleValue==5){
                row.forEach((seat) => {
                    if(seat.col_id === 1 || seat.col_id === row.length){
                        aisleUpdatedSeats.push({
                            ...seat,
                            seat_type: 1  //window
                        });
                    }
                    else if (seat.col_id === 5 || seat.col_id === 6) {
                        aisleUpdatedSeats.push({
                            ...seat,
                            seat_type: 3  //aisle
                        });
                    }
                    else{
                        // Other seats should have seat_type 2
                        aisleUpdatedSeats.push({
                            ...seat,
                            seat_type: 2
                        });
                    }
                })
            }
        });
    
    
        // Construct payload with aisleUpdatedSeats after updating the seating matrix
        const payload = {
            token: token,
            vehicle_id: rowData.id,
            aisle_column_id: newAisleValue,
            updated_seats: aisleUpdatedSeats
        };
    
        // Call the API to update the seats in the backend
        try {
            const url = operationsUrl + '/shuttle/add_update_seat_structure';
            const response = await makePostRequestToUrl(url, payload);
    
            if (response.flag === 200) {
                setMessage('Seats updated successfully.');
                showSnackbar(true);
                setSelectedSeatNumbers({});
                fetchSeatData();
                setModifiedSeats([]);
                setModifiedSeats2([]);
                setSubtracting(false);
                setSubtractingModifiedSeats([]);
                setAction(false);
                setIsRear(false);
            } else if (response.flag === 102) {
                console.log('Token is expired. Please login again');
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
    
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            } else {
                setMessage(response.message);
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }
    };
    

    return(
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Seat Structure</Typography>

            <Grid2 className='mainBox' sx={{marginTop:'2%', height:'auto'}}>
                <Grid2 container spacing={2} sx={{alignItems:'center'}}>
                    <Grid2 item sx={{display:'flex'}}>
                        <img height="24px" width="24px" src={windowSeat} alt="window seat"/>
                        <Typography sx={{fontSize:'15px'}}>Window Seat</Typography>
                    </Grid2>
                    <Grid2 item sx={{display:'flex'}}>
                        <img height="24px" width="24px" src={middleSeat} alt="middle seat"/>
                        <Typography sx={{fontSize:'15px'}}>Middle Seat</Typography>
                    </Grid2>
                    <Grid2 item sx={{display:'flex'}}>
                        <img height="24px" width="24px" src={aisleSeat} alt="aisle seat"/>
                        <Typography sx={{fontSize:'15px'}}>Aisle Seat</Typography>
                    </Grid2>
                    <Grid2 item sx={{display:'flex'}}>
                        <img height="24px" width="24px" src={specialSeat} alt="special seat"/>
                        <Typography sx={{fontSize:'15px'}}>Special Seat</Typography>
                    </Grid2>
                    <Grid2 item sx={{display:'flex'}}>
                        <img height="24px" width="24px" src={inactiveNew} alt="inactive seat"/>
                        <Typography sx={{fontSize:'15px'}}>Inactive Seat</Typography>
                    </Grid2>
                    <Grid2 item sx={{display:'flex'}}>
                        <img height="24px" width="24px" src={femaleSeat} alt="female seat"/>
                        <Typography sx={{fontSize:'15px'}}>Female Seat</Typography>
                    </Grid2>
                    {/* <Grid2 item sx={{display:'flex'}}>
                        <img height="24px" width="24px" src={windowAisle} alt="female seat"/>
                        <Typography sx={{fontSize:'15px'}}>Window-Aisle Seat</Typography>
                    </Grid2> */}

                    {(!openEdit) && (
                        <Grid2 item sx={{marginLeft:'auto'}}>
                            <Button onClick={handleOpenEdit} sx={{border:'1px solid #0065FF', textTransform:'none', backgroundColor:'#F3F8FF', borderRadius:'10px', padding:'8px 16px'}}>
                                <Typography sx={{color: '#0065FF'}}>Edit Seat Structure </Typography>
                            </Button>
                        </Grid2>
                    )}
                        

                    {(openEdit) && (
                        <Grid2 item sx={{marginLeft:'auto'}}>
                            {(openEdit) && (
                                <Grid2>
                                    <Button sx={{textTransform:'none', backgroundColor:'#0065FF', borderRadius:'10px', padding:'8px'}} onClick={savingStructure}> 
                                        <Typography sx={{color:'#fff'}}>Save Structure</Typography>
                                    </Button>
                                </Grid2>
                            )}

                            {/* {openEdit && (
                                <Grid2>
                                    <Button sx={{textTransform:'none', backgroundColor:'#0065FF', borderRadius:'10px', padding:'8px'}} onClick={handleUpdateData}> 
                                        <Typography sx={{color:'#fff'}}>Update</Typography>
                                    </Button>
                                </Grid2>
                            )} */}
                        </Grid2>
                    )}

                </Grid2>

                <hr/>
                

                <Grid2 item sx={{display:'flex', justifyContent: 'center'}}>
                    <Grid2 sx={{border:'1px solid #D1D5DB', borderRadius:'12px', width:'auto', height:'auto', marginTop:'2%', justifyItems:'center', padding:'18px'}}>
                        {openEdit && (
                            <Grid2 sx={{backgroundColor:'#FBE3A1', borderRadius:'8px', textAlign:'center', padding:'4px', width:'100%', marginBottom:'2%'}}>
                                <Typography>Click on Any Seat icon to change type</Typography>
                                <Typography sx={{color:'#83888E'}}>(Like : window seat, special seat)</Typography>
                            </Grid2>
                        )}
                            
                        <Grid2 sx={{display:'flex'}} spacing={1}>

                            <Grid2 container direction="column" spacing={1}>
                                {seatingMatrix.map((row, rowIndex) => {
                                    // Filter out any null seats.
                                    const filteredRow = row.filter(seat => seat !== null);
                                    // Find the index of the first aisle seat in this filtered row.
                                    const firstAisleIndex = filteredRow.findIndex(seat => (seat.seat_type === 3||seat.seat_type === 7));
                                    
                                    return (
                                        <Grid2 container key={rowIndex} spacing={1} alignItems="center">
                                            {filteredRow.map((seat, colIndex) => (
                                                <React.Fragment key={colIndex}>
                                                <Grid2 container direction="column" alignItems="center" sx={{margin:'4px', border:openEdit?'1px solid #D1D5DB':'none', borderRadius:'6px', padding:'4px', backgroundColor:openEdit?'#F9F9F9':'none'}}>
                                                    <Grid2 item onClick={(event) => handleClick(event, seat)}>
                                                        {seat.seat_type === 1 && (
                                                            <img src={windowSeat} alt={`Seat ${seat.seat_number}`} />
                                                        )}
                                                        {seat.seat_type === 2 && (
                                                            <img src={middleSeat} alt={`Seat ${seat.seat_number}`} />
                                                        )}
                                                        {seat.seat_type === 3 && (
                                                            <img src={aisleSeat} alt={`Seat ${seat.seat_number}`} />
                                                        )}
                                                        {seat.seat_type === 4 && (
                                                            <img src={specialSeat} alt={`Seat ${seat.seat_number}`} />
                                                        )}
                                                        {seat.seat_type === 5 && (
                                                            <img src={inactiveNew} alt={`Seat ${seat.seat_number}`} />
                                                        )}
                                                        {seat.seat_type === 6 && (
                                                            <img src={femaleSeat} alt={`Seat ${seat.seat_number}`} />
                                                        )}
                                                        {/* {seat.seat_type === 7 && (
                                                            <img src={windowAisle} alt={`Seat ${seat.seat_number}`} />
                                                        )} */}
                                                    </Grid2>

                                                    {openEdit && (
                                                        <Grid2 item sx={{ padding: '0px' }}>
                                                            <TextField
                                                                sx={{ height: '30px', width: '50px' }} type="text"
                                                                value={selectedSeatNumbers[seat.seat_id]?.seat_number ?? seat.seat_number}
                                                                onChange={(e) => {
                                                                    const newValue = e.target.value;
                                                                    // Only update the seat number if the value is empty or a valid number
                                                                    if (newValue === '' || /^[0-9]*$/.test(newValue)) {
                                                                      handleSeatChange(seat.seat_id, newValue);
                                                                    }
                                                                  }}
                                                                InputProps={{
                                                                sx: {
                                                                    padding: '0px',
                                                                    '& input': { padding: '0px', textAlign: 'center' }
                                                                }
                                                                }}
                                                            />
                                                        </Grid2>
                                                    )}
                                                    {!openEdit && (
                                                        <Grid2 sx={{border:'1px solid #D1D5DB', borderRadius:'6px', width:'40px', backgroundColor:'#fff'}}>
                                                            <Typography sx={{textAlign:'center'}}>{selectedSeatNumbers[seat.seat_id]?.seat_number || seat.seat_number}</Typography>
                                                        </Grid2>
                                                    )}
                                                    
                                                </Grid2>

                                                {/* Render aisle image only after the first aisle seat */}
                                                {(seat.is_aisle===1) && (
                                                    <Grid2 item>
                                                        <img
                                                            src={aisleImage}
                                                            alt="Aisle"
                                                            style={{ width: '50px', height: '28px' }}
                                                        />
                                                    </Grid2>
                                                )}

                                                </React.Fragment>
                                            ))}
                                        </Grid2>
                                    );
                                })}

                                {(openEdit) && (
                                    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                                        <MenuItem onClick={() => handleSeatTypeChange(1)}>
                                        <img src={windowSeat} alt="Window Seat" /> Window Seat
                                        </MenuItem>
                                        <MenuItem onClick={() => handleSeatTypeChange(2)}>
                                        <img src={middleSeat} alt="Middle Seat" /> Middle Seat
                                        </MenuItem>
                                        <MenuItem onClick={() => handleSeatTypeChange(3)}>
                                        <img src={aisleSeat} alt="Aisle Seat" /> Aisle Seat
                                        </MenuItem>
                                        <MenuItem onClick={() => handleSeatTypeChange(4)}>
                                        <img src={specialSeat} alt="Special Seat" /> Special Seat
                                        </MenuItem>
                                        <MenuItem onClick={() => handleSeatTypeChange(5)}>
                                        <img src={inactiveNew} alt="Inactive" /> Inactive
                                        </MenuItem>
                                        <MenuItem onClick={() => handleSeatTypeChange(6)}>
                                        <img src={femaleSeat} alt="Female Seat" /> Female Seat
                                        </MenuItem>
                                        {/* <MenuItem onClick={() => handleSeatTypeChange(7)}>
                                        <img src={windowAisle} alt="Window-Aisle Seat" />Window-Aisle Seat
                                        </MenuItem> */}
                                    </Menu>
                                )}
                            </Grid2>

                        </Grid2>
                        
                        <Grid2 sx={{marginTop:'2%'}}>
                            <img src={rearImage} height="36px" alt="aisle image" />
                        </Grid2>

                        <Grid2>
                            {rearSeatingMatrix.map((row, rowIndex) => {
                                // Filter out any null seats.
                                const filteredRow = row.filter(seat => seat !== null);
                                // Find the index of the first aisle seat in this filtered row.
                                const firstAisleIndex = filteredRow.findIndex(seat => seat.seat_type === 3);
                                
                                return (
                                    <Grid2 container key={rowIndex} spacing={1} alignItems="center">
                                        {filteredRow.map((seat, colIndex) => (
                                            <React.Fragment key={colIndex}>
                                                <Grid2 container direction="column" alignItems="center" sx={{margin:'4px', border:openEdit?'1px solid #D1D5DB':'none', borderRadius:'6px', padding:'4px', backgroundColor:openEdit?'#F9F9F9':'none'}}>
                                                    <Grid2 item onClick={(event) => handleClick(event, seat)}>
                                                        {seat.seat_type === 1 && (
                                                            <img src={windowSeat} alt={`Seat ${seat.seat_number}`} />
                                                        )}
                                                        {seat.seat_type === 2 && (
                                                            <img src={middleSeat} alt={`Seat ${seat.seat_number}`} />
                                                        )}
                                                        {seat.seat_type === 3 && (
                                                            <img src={aisleSeat} alt={`Seat ${seat.seat_number}`} />
                                                        )}
                                                        {seat.seat_type === 4 && (
                                                            <img src={specialSeat} alt={`Seat ${seat.seat_number}`} />
                                                        )}
                                                        {seat.seat_type === 5 && (
                                                            <img src={inactiveNew} alt={`Seat ${seat.seat_number}`} />
                                                        )}
                                                        {seat.seat_type === 6 && (
                                                            <img src={femaleSeat} alt={`Seat ${seat.seat_number}`} />
                                                        )}
                                                        {seat.seat_type === 7 && (
                                                            <img src={windowAisle} alt={`Seat ${seat.seat_number}`} />
                                                        )}
                                                    </Grid2>

                                                    {openEdit && (
                                                        <Grid2 item sx={{ padding: '0px' }}>
                                                            <TextField
                                                                sx={{ height: '30px', width: '50px' }}
                                                                value={selectedSeatNumbers[seat.seat_id]?.seat_number ?? seat.seat_number}
                                                                // onChange={(e) => handleSeatChange(seat.seat_id, e.target.value)}
                                                                onChange={(e) => {
                                                                    const newValue = e.target.value;
                                                                    // Only update the seat number if the value is empty or a valid number
                                                                    if (newValue === '' || /^[0-9]*$/.test(newValue)) {
                                                                      handleSeatChange(seat.seat_id, newValue);
                                                                    }
                                                                }}
                                                                InputProps={{
                                                                sx: {
                                                                    padding: '0px',
                                                                    '& input': { padding: '0px', textAlign: 'center' }
                                                                }
                                                                }}
                                                            />
                                                        </Grid2>
                                                    )}
                                                    {!openEdit && (
                                                        <Grid2 sx={{border:'1px solid #D1D5DB', borderRadius:'6px', width:'40px', backgroundColor:'#fff'}}>
                                                            <Typography sx={{textAlign:'center'}}>{selectedSeatNumbers[seat.seat_id]?.seat_number || seat.seat_number}</Typography>
                                                        </Grid2>
                                                    )}
                                                    
                                                </Grid2>
                                            </React.Fragment>
                                        ))}
                                    </Grid2>
                                );
                            })}
                        </Grid2>
                        
                    </Grid2>

                    {openEdit && (
                        <Grid2 sx={{marginTop:'2%', marginLeft:'4%'}}>

                            <Grid2 sx={{border:'1px solid #D1D5DB', borderRadius:'12px', backgroundColor:'#F9F9F9', padding:'12px', marginTop:'8%', width:'184px'}}>
                                <Typography>Seats after which aisle appears:</Typography>
                                <Grid2 item sx={{display:'flex', padding:'8px', borderRadius:'8px', marginTop:'4%', justifyContent:'center', width: '160px'}}>
                                    
                                    <Select value={isAisle} onChange={(e) => aislePosition(e.target.value)} displayEmpty
                                    style={{width: '220px',height:'50px',borderRadius:'8px',backgroundColor: '#F9F9F9'}}>
                                        {/* <MenuItem value="">Select City</MenuItem> */}
                                        {seatingMatrix && seatingMatrix[0]?.slice(0, seatingMatrix[0].length - 1)?.map((topRow) => (
                                            <MenuItem key={topRow.col_id} value={topRow.col_id}>
                                            {topRow.col_id}
                                            </MenuItem>
                                        ))}
                                        {/* {seatingMatrix[0].map((topRow) => (
                                            <MenuItem key={topRow.col_id} value={topRow.col_id}>
                                                {topRow.col_id}
                                            </MenuItem>
                                        ))} */}
                                    </Select>
                                </Grid2>
                            </Grid2>

                            <Grid2 sx={{border:'1px solid #D1D5DB', borderRadius:'12px', backgroundColor:'#F9F9F9', padding:'12px', marginTop:'8%', width:'184px'}}>
                                <Typography>Row</Typography>
                                <Grid2 item sx={{display:'flex', border :'1px solid #D1D5DB', padding:'8px', borderRadius:'8px', marginTop:'4%', justifyContent:'center', width: '160px'}}>
                                    <img onClick={addRowOnRight} src={addCircle} style={{marginRight: '8px'}} alt="add"/>
                                    <img onClick={subtractRowOnRight} src={removeCircle} alt="subtract"/>
                                </Grid2>
                            </Grid2>

                            <Grid2 sx={{border:'1px solid #D1D5DB', borderRadius:'12px', backgroundColor:'#F9F9F9', padding:'12px', marginTop:'8%', width:'184px'}}>
                                <Typography>Column</Typography>
                                {/* <Grid2 item sx={{display:'flex', border :'1px solid #D1D5DB', padding:'8px', borderRadius:'8px', marginTop:'4%', justifyContent:'center', width: '160px'}}>
                                    <Typography sx={{marginRight:'6px'}}>Column</Typography>
                                    <Grid2 sx={{marginLeft:'auto'}}>
                                        <img onClick={addColumnOnRight} src={addCircle} style={{marginRight:'6px'}} alt="add"/>
                                        <img onClick={subtractColumnOnRight} src={removeCircle} alt="subtract"/>
                                    </Grid2>
                                    
                                </Grid2> */}
                                <Grid2 item sx={{display:'flex', border :'1px solid #D1D5DB', padding:'8px', borderRadius:'8px', marginTop:'4%', justifyContent:'center', width: '160px'}}>
                                    <img onClick={addColumnOnRight} src={addCircle} style={{marginRight: '8px'}} alt="add"/>
                                    <img onClick={subtractColumnOnRight} src={removeCircle} alt="subtract"/>
                                </Grid2>
                            </Grid2>

                            {/* <Grid2 sx={{border:'1px solid #D1D5DB', borderRadius:'12px', backgroundColor:'#F9F9F9', padding:'12px', marginTop:'8%', width:'184px'}}>
                                <Typography>Left Seating</Typography>
                                
                                <Grid2 item sx={{display:'flex', border :'1px solid #D1D5DB', padding:'8px', borderRadius:'8px', marginTop:'4%', justifyContent:'center', width: '160px'}}>
                                    <Typography  sx={{marginRight:'6px'}}>Column</Typography>
                                    <Grid2 sx={{marginLeft:'auto'}}>
                                        <img onClick={addColumnOnLeft} src={addCircle} style={{marginRight:'6px'}} alt="add"/>
                                        <img onClick={subtractColumnOnLeft} src={removeCircle} alt="subtract"/>
                                    </Grid2>
                                </Grid2>
                            </Grid2> */}

                            <Grid2 sx={{border:'1px solid #D1D5DB', borderRadius:'12px', backgroundColor:'#F9F9F9', padding:'12px', marginTop:'8%', width:'184px'}}>
                                <Typography>Rear Seat</Typography>
                                <Grid2 item sx={{display:'flex', border :'1px solid #D1D5DB', padding:'8px', borderRadius:'8px', marginTop:'4%', justifyContent:'center', width: '160px'}}>
                                    <Grid2>
                                        <img onClick={addRear} src={addCircle} style={{marginRight:'8px'}} alt="add"/>
                                        <img onClick={subtractRear} src={removeCircle} alt="subtract"/>
                                    </Grid2>
                                </Grid2>
                            </Grid2>
                            
                        </Grid2>
                    )}
                    
                </Grid2>

            </Grid2>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>

        </div>
        
    )
}

export default ShuttleSeatStructure;